/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Output_Truncated_DetailInputs */



/**
* | output |
* | --- |
* | "The model reached its output limit, so this answer is shorter than intended. Ask it to continue, or split the request into smaller steps." |
*
* @param {Chat_Output_Truncated_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_output_truncated_detail = /** @type {((inputs?: Chat_Output_Truncated_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Output_Truncated_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Modell hat sein Ausgabelimit erreicht, deshalb ist diese Antwort kürzer als beabsichtigt. Bitten Sie um eine Fortsetzung oder teilen Sie die Anfrage in kleinere Schritte auf.")
	return /** @type {LocalizedString} */ ("The model reached its output limit, so this answer is shorter than intended. Ask it to continue, or split the request into smaller steps.")
});